import { getOrderedWeekdays } from './getOrderedWeekdays';
export function getWeeksForMonth(year, month) {
    const date = new Date(year, month, 1);
    const weeks = [];
    let currentWeek = 0;
    let currentDay = getOrderedWeekdays().indexOf(date.getDay());
    /*
     * start by filling the week with empty values until we reach the current day of the month
     * then map them to the dates of the remaining days of the last month
     */
    weeks[0] = Array.from(Array(currentDay))
        .map((_, index) => new Date(date.getFullYear(), date.getMonth(), date.getDate() - index - 1, 0, 0, 0, 0))
        .reverse();
    // fill the weekdays with dates until we reach the next month
    while (date.getMonth() === month) {
        if (weeks[currentWeek].length >= 7) {
            ++currentWeek;
            currentDay = 0;
        }
        if (!weeks[currentWeek]) {
            weeks[currentWeek] = [];
        }
        weeks[currentWeek].push(new Date(date));
        date.setDate(date.getDate() + 1);
    }
    // fill the remaining days of the week with dates from the following month
    if (weeks[currentWeek].length < 7) {
        weeks[currentWeek].push(...Array.from(Array(7 - weeks[currentWeek].length)).map((_, index) => new Date(date.getFullYear(), date.getMonth(), date.getDate() + index)));
    }
    return weeks;
}
//# sourceMappingURL=getWeeksForMonth.js.map